(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/use-selected-sportkryss.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/use-selected-sportkryss.js');
"use strict";

const tipsenApi = svs.components.tipsen.store.tipsenApi;
const useSelectedSportkryss = (year, month, currentDateDraw, sportKryssFactors) => {
  var _dateData$data;
  if (sportKryssFactors && (sportKryssFactors === null || sportKryssFactors === void 0 ? void 0 : sportKryssFactors.length) < 2) {
    return [undefined, false, false];
  }
  const dateData = tipsenApi.useGetResultDatePickerQuery({
    product: 'sportkrysset',
    month,
    year
  }, {
    refetchOnMountOrArgChange: true,
    skip: !month || !year
  });
  const sportkryssetDraw = dateData === null || dateData === void 0 || (_dateData$data = dateData.data) === null || _dateData$data === void 0 ? void 0 : _dateData$data.resultDates.find(resultDate => dateFns.isSameDay(new Date(resultDate === null || resultDate === void 0 ? void 0 : resultDate.date), new Date(currentDateDraw === null || currentDateDraw === void 0 ? void 0 : currentDateDraw.date)));
  const drawNumber = sportkryssetDraw === null || sportkryssetDraw === void 0 ? void 0 : sportkryssetDraw.drawNumber;
  const _tipsenApi$useGetSpor = tipsenApi.useGetSportkryssResultQuery({
      drawNumber
    }, {
      refetchOnMountOrArgChange: true,
      skip: !drawNumber
    }),
    data = _tipsenApi$useGetSpor.data,
    isLoading = _tipsenApi$useGetSpor.isLoading,
    isError = _tipsenApi$useGetSpor.isError;
  const hasDataForCurrentDraw = dateFns.isSameDay(new Date(data === null || data === void 0 ? void 0 : data.result.regCloseTime), new Date(currentDateDraw === null || currentDateDraw === void 0 ? void 0 : currentDateDraw.date));
  let fetchedData = hasDataForCurrentDraw ? data : undefined;
  const winDivArray = [];
  if (fetchedData && !isError) {
    fetchedData.result.distribution.map(item => winDivArray.push({
      winDiv: parseInt(item.name.split('')[0], 10),
      winners: item.winners,
      winValue: item.amount
    }));
    fetchedData = {
      winDivArray,
      data
    };
  }
  const loadingSportkrysset = isLoading || !currentDateDraw || !(currentDateDraw !== null && currentDateDraw !== void 0 && currentDateDraw.productId);
  return [fetchedData, loadingSportkrysset];
};
setGlobal('svs.components.tipsen.routeResult.useSelectedSportkryss', useSelectedSportkryss);

 })(window);